import { MessageSquare, Eye, Link } from 'lucide-react';

/**
 * Statistics Display Component
 */
export function Stats({ stats }) {
  if (!stats) return null;

  const statItems = [
    {
      icon: MessageSquare,
      label: 'Messages',
      value: stats.messageCount,
      color: 'text-blue-600',
      bg: 'bg-blue-50'
    },
    {
      icon: Eye,
      label: 'Hidden Thoughts',
      value: stats.thoughtCount,
      color: 'text-purple-600',
      bg: 'bg-purple-50'
    },
    {
      icon: Link,
      label: 'Has Grounding',
      value: stats.hasGrounding ? 'Yes' : 'No',
      color: 'text-green-600',
      bg: 'bg-green-50'
    }
  ];

  return (
    <div className="grid grid-cols-3 gap-3 mt-4">
      {statItems.map((item, index) => (
        <div key={index} className={`${item.bg} rounded-lg p-3`}>
          <div className="flex items-center gap-2 mb-1">
            <item.icon className={`w-4 h-4 ${item.color}`} />
          </div>
          <div className="text-xl font-bold text-slate-900">{item.value}</div>
          <div className="text-xs text-slate-600">{item.label}</div>
        </div>
      ))}
    </div>
  );
}
